module.exports = __webpack_public_path__ + "logo.png?93a894ed47521967da87a873de3711f7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = 65
// module chunks = 13